import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';
import Draggable from 'react-draggable';

ChartJS.register(ArcElement, Tooltip);

const NewCircularProgressChart = ({
    progress,
    dateTimesLive,
    dataArrLive,
    chartChannel,
    maxVal = 1000
}) => {

    const [chartData, setChartData] = useState({
        datasets: [],
    });

    const [chartOptions, setChartOptions] = useState({});
    const [percentage, setPercentage] = useState(0);

    useEffect(() => {
        const matchedDataset =
            chartChannel?.length > 0
                ? dataArrLive?.find((dataset) => dataset.label === chartChannel[0])
                : null;

        let currentVal = matchedDataset?.data?.slice(-1)[0] ?? 500;

        currentVal = currentVal > maxVal ? maxVal : currentVal;

        const newPercentage = Math.min((currentVal / maxVal) * 100, 100);
        setPercentage(newPercentage.toFixed(1)); // Round for clean display

        const data = {
            datasets: [
                {
                    data: [currentVal, maxVal - currentVal],
                    backgroundColor: ['#4caf50', '#e0e0e0'],
                    borderWidth: 0,
                    cutout: '75%',
                },
            ],
        };

        const options = {
            cutout: '75%',
            rotation: -90,
            circumference: 360,
            plugins: {
                tooltip: { enabled: false },
            },
        };

        setChartData(data);
        setChartOptions(options);
    }, [dateTimesLive, chartChannel, dataArrLive, maxVal]);

    return (
        <div style={{ width: '100%', height: '100%', position: 'relative' }}>
            {/* 🛡️ Guard against empty datasets */}
            {chartData?.datasets?.length > 0 && (
                <Doughnut data={chartData} options={chartOptions} />
            )}
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    fontWeight: 'bold',
                    fontSize: '1.2rem',
                }}
            >
                {percentage}%
            </div>
        </div>
    );
};


const CircularProgressChart = ({
    progress,
    dateTimesLive,
    dataArrLive,
    chartChannel,
    maxVal

}) => {

    const [chartData, setChartData] = useState({
        datasets: [],
    });

    const [chartOptions, setChartOptions] = useState({});
    const [percentage, setPercentage] = useState(0);

    useEffect(() => {

        const matchedDataset =
            chartChannel?.length > 0
                ? dataArrLive?.find((dataset) => dataset.label === chartChannel[0])
                : null;

        let currentVal = matchedDataset?.data?.slice(-1)[0] ?? 500;

        currentVal = currentVal > maxVal ? maxVal : currentVal;

        const newPercentage = Math.min((currentVal / maxVal) * 100, 100);
        setPercentage(newPercentage.toFixed(1)); // Round for clean display

        const data = {
            datasets: [
                {
                    data: [currentVal, maxVal - currentVal],
                    backgroundColor: ['#4caf50', '#e0e0e0'],
                    borderWidth: 0,
                    cutout: '75%',
                },
            ],
        };

        const options = {
            cutout: '75%',
            rotation: -90,
            circumference: 360,
            plugins: {
                tooltip: { enabled: false },
            },
        };

        setChartData(data);
        setChartOptions(options);
    }, [dateTimesLive, chartChannel, dataArrLive, maxVal]);

    return (

        <div style={{ width: '100%', height: '100%', position: 'relative' }}>
            {/* 🛡️ Guard against empty datasets */}
            {chartData?.datasets?.length > 0 && (
                <Doughnut data={chartData} options={chartOptions} />
            )}
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    fontWeight: 'bold',
                    fontSize: '1.2rem',
                }}
            >
                {percentage}%
            </div>
        </div>
    );
}

export { NewCircularProgressChart, CircularProgressChart };
